import { client } from '@/client';

// 提交试用反馈 免登录
export function feedBackSubmit(data) {
  return client.post('/crm-api/customer_feedback/addFeedBack', data);
}
